export const SAVE_INFO = 'SAVE_INFO';
export const SHOW_LOCALS = 'SHOW_LOCALS';
export const SAVE_USER = 'SAVE_USER';
export const TOGGLE_MENU = 'TOGGLE_MENU';
export const CLOSE_MENU = 'CLOSE_MENU';
